import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_GENERIC_SUSPENSION } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIdOlSospensioneState extends EntityState<IID_GENERIC_SUSPENSION, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_GENERIC_SUSPENSION })
export class IIDgenericSuspensionStore extends EntityStore<IIdOlSospensioneState> {
  constructor() {
    super([]);
  }
}
